import { getMediaEntity, getMediaType, getRootContainerId } from '~/composables/useMediaClassification';

export type ItemUrl = {
    type?: 'container' | 'item';
    id?: number | string;
    container?: any;
    item?: any;
};

/**
 * Генерирует URL на основе предоставленных параметров.
 *
 * @param item - Объект элемента.
 * @param type - Тип элемента.
 * @param compilation - Идентификатор компиляции.
 * @returns Сгенерированный URL.
 */
export default (item: ItemUrl, type?: string, compilation?: string) => {
    const resolvedType = !type || type === 'item' ? getMediaType(item, type) : type;
    const resolvedItem = getMediaEntity(item);
    const routeType = !type || type === 'item' ? resolvedType : type;
    const itemId =
        resolvedType === 'container' && (!type || type === 'item')
            ? getRootContainerId(item) || resolvedItem?.id
            : resolvedItem?.id;

    switch (routeType) {
        case 'channel': {
            const initialPath = '/live';
            const params = new URLSearchParams();

            if (compilation) {
                params.set('compilation', compilation);
            }

            if (itemId) {
                params.set('channel', String(itemId));
            }

            const queryString = params.toString();
            return queryString ? `${initialPath}?${queryString}` : initialPath;
        }
        case 'item':
            return `/item/${itemId}/detail`;
        case 'item-view':
            return `/item/${itemId}`;
        case 'container':
            return `/container/${itemId}`;
        default:
            switch (resolvedType) {
                case 'channel':
                    return itemId ? `/live?channel=${String(itemId)}` : '/live';
                case 'item':
                    return `/item/${itemId}/detail`;
                case 'container':
                    return `/container/${itemId}`;
                default:
                    return '#';
            }
    }
};
